<template>
  <div>
    <div class="row" v-if="!branchLogIn">
      <div class="col-sm text-left">1. Does your firm has any Financial Banker or Guarantor?</div>
      <div v-if="financialStrength.financialBanker=='Y'" class="col-sm text-left">
        <a
          @click="showFile(financialStrength.bankerDocument)"
          href="#"
        >{{getAttachmentName(financialStrength.bankerDocument)}}</a>
      </div>
      <div v-else class="col-sm text-left">No</div>
    </div>
    <div>
      <div v-if="financialStrength.bankers != ''" class="pb-3">
        <div class="inner-title col">Financial Bankers</div>
        <div class="table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Sl No</th>
                <th scope="col">Account Category</th>
                <th scope="col">Bank Name</th>
                <th scope="col">IFSC Code</th>
                <th scope="col">Years of Association</th>
                <th scope="col">Coordination Person Name</th>
                <th scope="col">Contact Designation</th>
                <th scope="col">Mobile Number</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="(banker,index) in financialStrength.bankers" :key="index">
                <td scope="col">{{index+1}}</td>
                <td scope="col">{{banker.bankerType}}</td>
                <td scope="col">{{banker.bankerName}}</td>
                <td scope="col">{{banker.ifscCode}}</td>
                <td scope="col">{{banker.yearOFAssociation}}</td>
                <td scope="col">{{banker.contactPersonName}}</td>
                <td scope="col">{{banker.designation}}</td>
                <td scope="col">{{banker.mobileNumber}}</td>
                <td scope="col">{{banker.email}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["financialStrength", "branchLogIn"],
  methods: {
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    }
  }
};
</script>
<style scoped>
.inner-title {
  /* width: 246px;
  height: 36px; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #000000;
  /* font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 13px; */
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
.my-custom-scrollbar {
  position: relative;
  height: 200px;
  width: 100%;
  overflow: auto;
}
</style>